import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-292b51ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "channel-status-cell"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelStatusCell',
  props: {
    rows: null
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, row => {
        return _openBlock(), _createElementBlock("div", {
          key: row.key,
          class: "channel-status-row"
        }, [_createVNode(_component_a_tooltip, {
          title: row.tooltip
        }, {
          default: _withCtx(() => [_createElementVNode("span", {
            class: _normalizeClass(["channel-tag", row.key])
          }, _toDisplayString(row.tag), 3)]),
          _: 2
        }, 1032, ["title"]), _createElementVNode("span", {
          class: _normalizeClass(["channel-status-dot", row.tone])
        }, null, 2), _createElementVNode("span", null, _toDisplayString(row.text), 1)]);
      }), 128))]);
    };
  }
});